export enum TradeDirection {
  input = "input",
  output = "output",
}
